// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICensusRequestDto } from './ICensusRequestDto';
import {
    ICensusRequestDtoFromJSON,
    ICensusRequestDtoFromJSONTyped,
    ICensusRequestDtoToJSON,
    ICensusRequestDtoToJSONTyped,
} from './ICensusRequestDto';

/**
 * 
 * @export
 * @interface ICensusResultDto
 */
export interface ICensusResultDto {
    /**
     * 
     * @type {ICensusRequestDto}
     * @memberof ICensusResultDto
     */
    census_request_dto?: ICensusRequestDto;
    /**
     * 
     * @type {number}
     * @memberof ICensusResultDto
     */
    failed_records_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ICensusResultDto
     */
    succeed_records_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ICensusResultDto
     */
    total_records_count_for_request?: number;
}

/**
 * Check if a given object implements the ICensusResultDto interface.
 */
export function instanceOfICensusResultDto(value: object): value is ICensusResultDto {
    return true;
}

export function ICensusResultDtoFromJSON(json: any): ICensusResultDto {
    return ICensusResultDtoFromJSONTyped(json, false);
}

export function ICensusResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICensusResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'census_request_dto': json['censusRequestDto'] == null ? undefined : ICensusRequestDtoFromJSON(json['censusRequestDto']),
        'failed_records_count': json['failedRecordsCount'] == null ? undefined : json['failedRecordsCount'],
        'succeed_records_count': json['succeedRecordsCount'] == null ? undefined : json['succeedRecordsCount'],
        'total_records_count_for_request': json['totalRecordsCountForRequest'] == null ? undefined : json['totalRecordsCountForRequest'],
    };
}

export function ICensusResultDtoToJSON(json: any): ICensusResultDto {
    return ICensusResultDtoToJSONTyped(json, false);
}

export function ICensusResultDtoToJSONTyped(value?: ICensusResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'censusRequestDto': ICensusRequestDtoToJSON(value['census_request_dto']),
        'failedRecordsCount': value['failed_records_count'],
        'succeedRecordsCount': value['succeed_records_count'],
        'totalRecordsCountForRequest': value['total_records_count_for_request'],
    };
}

